// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFocus } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../utils/enums";

export const ContentSocialBarStyles = (config: DesignSystem) => ({
    contentSocialBarContainer: {
        display: "flex !important",
        "align-items": "center",
        margin: "8px 3px 0",

        ["&." + enums.responsiveLevels.L0]: {
            "margin-bottom": "8px"
        }
    }
});